import { Experiment } from '@cian/experiments/ab';
import { useSelector, useDispatch } from 'react-redux';
import * as React from 'react';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { ShowMoreBtn } from '../../components/ShowMoreBtn';
import { IApplicationState } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';
import { selectActiveTab } from '../../selectors/activeTab';
import { ETabType } from '../../types/filters';
import { WrapContainer } from '../../components/WrapContainer';
import { PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT } from '../../constants/experiments';

export const ShowMoreBtnContainer = () => {
  const hasMore = useSelector((state: IApplicationState) => state.results.hasMore);
  const favoriteEntitiesLength = useSelector((state: IApplicationState) => state.results.favoriteEntities.length);
  const status = useSelector((state: IApplicationState) => state.results.status);
  const { activeTab, isInitialized } = useSelector(selectActiveTab);
  const dispatch = useDispatch();

  const loadMore = () => {
    dispatch(fetchFavoriteEntities({ offset: favoriteEntitiesLength, next: true }));
  };

  if (!hasMore || !favoriteEntitiesLength || !isInitialized || activeTab === ETabType.SavedSearches) {
    return null;
  }

  return (
    <>
      <Experiment name={PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT} group="A" default>
        <ShowMoreBtn onClick={loadMore} loading={status === EGetFavoriteEntitiesStatus.NextPageLoading} />
      </Experiment>
      <Experiment name={PERS_MOBILE_RECS_IN_FAVORITES_EXPERIMENT} group="B">
        <WrapContainer>
          <ShowMoreBtn onClick={loadMore} loading={status === EGetFavoriteEntitiesStatus.NextPageLoading} />
        </WrapContainer>
      </Experiment>
    </>
  );
};
